import { env } from 'next-runtime-env';

import { resolveV3 } from '../resolveV3';

interface IGoogleTiles {
  expiry: string;
  imageFormat: string;
  session: string;
  tileHeight: number;
  tileWidth: number;
}

export async function getGoogleTileSession(): Promise<IGoogleTiles> {
  const key = env('NEXT_PUBLIC_GOOGLE_MAPS_KEY');

  const { res, err } = await resolveV3(
    {
      data: {
        language: 'en-US',
        mapType: 'satellite',
        region: 'US',
      },
      method: 'POST',
      url: `https://tile.googleapis.com/v1/createSession?key=${key}`,
    },
    {
      withCredentials: false,
    }
  );
  if (err) throw err;

  return res?.data;
}
